import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { fetchGenericError } from './GenericErrorPageSlice';
import { GenericErrorPageContentSelector } from './GenericErrorPageContentSelector';
import { GenericErrorPage } from 'cpfr-common';

export function useGenericErrorPage(): AbstractContentState<GenericErrorPage> {
    return useCmsContent(fetchGenericError, GenericErrorPageContentSelector);
}
